var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.invoiceTypes,"item-value":"id","item-text":_vm.render,"clearable":"","return-object":""},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v(_vm._s(_vm.render(data.item)))]}}])},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }